// components/ui/SiteBanner.jsx
export default function SiteBanner() {
	return (
		<div className="fixed bottom-4 left-4 z-[9999] max-w-sm rounded-2xl border border-white/10 bg-espresso/90 backdrop-blur-xl shadow-2xl px-4 py-3 text-warm-alabaster">
			<div className="flex items-start gap-3">
				<div className="relative mt-1 flex h-3 w-3 flex-shrink-0">
					<span className="absolute inline-flex h-3 w-3 rounded-full bg-latte-gold opacity-75 animate-ping" />
					<span className="relative inline-flex h-3 w-3 rounded-full bg-latte-gold" />
				</div>

				<div className="space-y-1">
					<p className="text-sm font-semibold text-latte-gold">
						Modification du site internet
					</p>
					<p className="text-xs leading-relaxed text-warm-alabaster/80">
						🆕 Ajout des produits existants sur le site
					</p>
					<p className="text-xs leading-relaxed text-warm-alabaster/80">
						🆕 Ajout d&apos;un système de panier et de paiement en ligne
					</p>
					<p className="text-xs leading-relaxed text-warm-alabaster/80">
						🆕 Ajout d&apos;un système de gestion des commandes pour
						l&apos;équipe
					</p>
				</div>
			</div>

			<div className="mt-3 flex justify-end">
				<div className="flex items-center gap-2 text-xs text-warm-alabaster/80">
					<span>Dernière mise à jour :</span>
					<span className="font-semibold">4 août 2026</span>
				</div>
			</div>

			<div className="mt-3 flex justify-end">
				<div className="flex items-center gap-2 text-xs text-warm-alabaster/80">
					<span>Version :</span>
					<span className="font-semibold">v2.0.0</span>
				</div>
			</div>
		</div>
	);
}
